import { CheckCircle2, MailWarning } from "lucide-react";

export const SuccessStep = ({ t, code }) => (
  <div data-testid="register-success" className="p-10 flex flex-col items-center text-center gap-4">
    <CheckCircle2 className="w-12 h-12 text-white" strokeWidth={1.5} />
    <p className="font-heading text-lg font-bold">{t.modal.successTitle}</p>
    <p className="text-neutral-400 text-sm">{t.modal.successDesc}</p>
    {code && (
      <p data-testid="register-success-code" className="text-neutral-500 text-xs">
        {t.modal.yourCodeLabel}: <span className="font-mono text-neutral-300 font-bold">{code}</span>
      </p>
    )}
    <div data-testid="register-spam-note" className="flex items-start gap-2.5 rounded-xl border border-brand-blue/30 bg-brand-blue/[0.06] p-4 mt-2 text-left">
      <MailWarning className="w-4 h-4 text-brand-blue shrink-0 mt-0.5" />
      <p className="text-neutral-300 text-xs leading-relaxed">{t.modal.spamNote}</p>
    </div>
  </div>
);
